<neo-error
  [errorCode]="500"
  [errorDescription]="'¡UY! Algo no ha salido como esperábamos...'"></neo-error>
